import { IconNames } from '@blueprintjs/icons';
import { isBefore, parseISO } from 'date-fns';

import { arrayIcon, booleanIcon, textIcon } from './custom-icons';

export function getLastCreatedItem(items: any[]) {
  if (!items) return null;

  return items.reduce((acc, item) => {
    if (!acc) return item;

    const itemCreationDate = parseISO(item.created_on_utc);
    const accCreationDate = parseISO(acc.created_on_utc);
    return isBefore(accCreationDate, itemCreationDate) ? item : acc;
  }, null);
}

interface columnIconProps {
  column:any;
  size?:number;
  color?:string;
  viewBox?:string;
}

export const columnIcon = ({ column, color, size, viewBox }:columnIconProps):any => {
  const type = column?.columnType || column?.type;
  switch (type) {
    case 'DECIMAL':
    case 'DOUBLE':
    case 'BIGINT':
    case 'FLOAT':
    case 'INT':
    case 'NUMBER':
      return IconNames.NUMERICAL;
    case 'STRING':
      return textIcon({ width: size, height: size, fill: color, viewBoxDefault: viewBox });
    case 'DATETIME':
    case 'DATE':
      return IconNames.CALENDAR;
    case 'BOOL':
    case 'BOOLEAN':
      return booleanIcon({ width: size, height: size, fill: color, viewBoxDefault: viewBox });
    case 'MAP':
    case 'ARRAY':
      return arrayIcon({ width: size, height: size, fill: color, viewBoxDefault: viewBox });
    default:
      return IconNames.DOT;
  }
};

export const COLUMN_CATEGORIES = {
  NUMBER: 'NUMBER',
  STRING: 'STRING',
  DATETIME: 'DATETIME',
  BOOLEAN: 'BOOLEAN',
  ARRAY: 'ARRAY'
};

export const columnCategory = (column: any) => {
  // Possible categories: STRING (default), NUMBER, DATE, BOOLEAN
  const type = column?.data_type || column?.type;

  switch (type) {
    case 'INT':
    case 'NUMBER':
      return COLUMN_CATEGORIES.NUMBER;
    case 'STRING':
      return COLUMN_CATEGORIES.STRING;
    case 'DATETIME':
    case 'DATE':
      return COLUMN_CATEGORIES.DATETIME;
    case 'BOOL':
    case 'BOOLEAN':
      return COLUMN_CATEGORIES.BOOLEAN;
    case 'ARRAY':
      return COLUMN_CATEGORIES.ARRAY;
    default:
      // By default considered as string
      return COLUMN_CATEGORIES.STRING;
  }
};
